var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 137,
    viewBox: "0 0 137 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101 128C115.912 128 128 115.912 128 101C128 86.0883 115.912 74 101 74C86.0883 74 74 86.0883 74 101C74 115.912 86.0883 128 101 128Z",
    stroke: "#5A636A",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9031 81.9038L120.097 120.098",
    stroke: "#5A636A",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64 100H24C19.5817 100 16 96.4183 16 92V36C16 31.5817 19.5817 28 24 28H104C108.418 28 112 31.5817 112 36V65.5",
    stroke: "#5A636A",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 60.0001H44.4C45.3212 59.995 46.2152 60.312 46.9274 60.8964C47.6396 61.4807 48.1251 62.2956 48.3 63.2001C49.0639 66.7977 51.0401 70.0238 53.898 72.3386C56.756 74.6534 60.3222 75.9165 64 75.9165C67.6778 75.9165 71.244 74.6534 74.102 72.3386C76.9599 70.0238 78.9361 66.7977 79.7 63.2001C79.8749 62.2956 80.3604 61.4807 81.0726 60.8964C81.7848 60.312 82.6788 59.995 83.6 60.0001H112",
    stroke: "#5A636A",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 44H112",
    stroke: "#5A636A",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentError);
export default __webpack_public_path__ + "static/media/payment-error.f8c51916383e17dcef8ec47c025033cd.svg";
export { ForwardRef as ReactComponent };